import Vue from 'vue/dist/vue.esm';
import ApplianceModal from './ApplianceModal.vue';

$(function(){

    const $modalWrapper = $('#applianceModalWrapper');

    if ( $modalWrapper.length ) {
        const apllianceModal = new Vue({
            name: 'ApplianceModal',
            el: '#applianceModalWrapper',
            components: {
                ApplianceModal
            }
        });
    }

});